import { TChatDashboardSettingsAction } from 'app/store/model/chatDashboardSettings/actions/types';

export const AT_CHAT_DASHBOARD_SETTINGS_ACTION_SET = 'CHAT_DASHBOARDS_SETTINGS__CHAT_DASHBOARD_SETTINGS_ACTION_SET';

export interface IChatDashboardSettingsActionSetAction {
    type: typeof AT_CHAT_DASHBOARD_SETTINGS_ACTION_SET,
    boardId: number,
    chatDashboardSettingsAction: TChatDashboardSettingsAction
}

export type TChatDashboardsSettingsAction = (IChatDashboardSettingsActionSetAction);
